import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TrendingUp, TrendingDown, Home as HomeIcon, PiggyBank, Banknote,
  Target, Star, Heart, Calculator, LogOut, Flame
} from "lucide-react";
import { LOGO_URL } from "@/config";
import SIPCalculatorTab from "@/components/calculators/SIPCalculatorTab";
import EMICalculatorTab from "@/components/calculators/EMICalculatorTab";
import FVCalculatorTab from "@/components/calculators/FVCalculatorTab";
import GoalCalculatorTab from "@/components/calculators/GoalCalculatorTab";
import RetirementCalculatorTab from "@/components/calculators/RetirementCalculatorTab";
import LifeGoalCalculatorTab from "@/components/calculators/LifeGoalCalculatorTab";
import SWPCalculatorTab from "@/components/calculators/SWPCalculatorTab";
import InflationCalculatorTab from "@/components/calculators/InflationCalculatorTab";

const tabs = [
  { id: 'sip', label: 'SIP Growth', icon: TrendingUp },
  { id: 'emi', label: 'EMI', icon: Banknote },
  { id: 'fv', label: 'Lumpsum Growth', icon: Target },
  { id: 'goal', label: 'Goal', icon: Star },
  { id: 'retirement', label: 'Retirement', icon: PiggyBank },
  { id: 'lifegoal', label: 'Life Goal', icon: Heart },
  { id: 'swp', label: 'SWP', icon: TrendingDown },
  { id: 'inflation', label: 'Inflation', icon: Flame },
];

const TAB_COMPONENTS = {
  sip: SIPCalculatorTab,
  emi: EMICalculatorTab,
  fv: FVCalculatorTab,
  goal: GoalCalculatorTab,
  retirement: RetirementCalculatorTab,
  lifegoal: LifeGoalCalculatorTab,
  swp: SWPCalculatorTab,
  inflation: InflationCalculatorTab,
};

const FinancialCalculators = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('sip');

  const ActiveComponent = TAB_COMPONENTS[activeTab];

  return (
    <div className="finance-app min-h-screen p-3 sm:p-6 lg:p-8" data-testid="calculators-page">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-4 sm:mb-8 page-header-mobile">
          <div className="flex items-center gap-2 sm:gap-4">
            <img src={LOGO_URL} alt="SubiWealth" className="h-8 sm:h-12" />
            <h1 className="page-title flex items-center gap-2"><Calculator size={22} className="text-teal-600" /> Financial Calculators</h1>
          </div>
          <div className="flex items-center gap-2 sm:gap-4 header-actions">
            <button className="nav-btn primary" onClick={() => navigate("/")}><HomeIcon size={16} className="inline mr-1" /> Dashboard</button>
            <button className="p-2 text-gray-500 hover:text-red-500" onClick={onLogout}><LogOut size={18} /></button>
          </div>
        </div>

        <div className="flex gap-2 mb-4 sm:mb-6 calc-tab-strip">
          {tabs.map((tab) => (
            <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center gap-1.5 px-3 sm:px-4 py-2 rounded-full font-medium transition-all text-sm ${activeTab === tab.id ? 'bg-teal-500 text-white shadow-md' : 'bg-white text-gray-600 hover:bg-gray-100'}`}>
              <tab.icon size={18} /> {tab.label}
            </button>
          ))}
        </div>

        <ActiveComponent />
      </div>
    </div>
  );
};

export default FinancialCalculators;
